import { BIKE_TAB, SITE_TAB, VOUCHER_TAB } from './types';

export const bikeTabAction = (tab) => (
  {
    type: BIKE_TAB,
    payload: tab,
  }
);
export const siteTabAction = (tab) => (
  {
    type: SITE_TAB,
    payload: tab,
  }
);
export const voucherTabAction = (tab) => (
  {
    type: VOUCHER_TAB,
    payload: tab,
  }
);

export function changeBikeTabAction(tab) {
  return (dispatch) => {
    dispatch(bikeTabAction(tab));
  };
}

export function changeSiteTabAction(tab) {
  return (dispatch) => {
    dispatch(siteTabAction(tab));
  };
}

export function changeVoucherTabAction(tab) {
  return (dispatch) => {
    dispatch(voucherTabAction(tab));
  };
}




// WEBPACK FOOTER //
// ./src/store/ui/actions.js